// IE 2026 11 02 / ODOO-349799 (group-levels) (заказ Игоря, скрин «Конфігурація» по чипу «Вид, Підсистема»): строки-группы wijmo (GroupRow
// сгруппированного списка) выглядели одинаково на всех уровнях и без элементов иерархии слева. Здесь — чистые расчёты: класс строки-группы
// по уровню (нулевой темнее и жирнее, глубже светлее; фон уровня только без своей заливки — правило / именованный стиль / hslGroup главнее)
// и геометрия направляющих слева по образцу дерева REPORT2 (AttrGrid formatItem_cells_break: оверлеи cell-frame-left / cell-divider-left).
// Выключатель fe.ux.gridGroupLevels (по умолчанию ВКЛ; false — поведение до правки: ни классов уровня, ни направляющих).

export const GROUP_LEVELS_FLAG = 'fe.ux.gridGroupLevels'

export function groupLevels_on(store) {
    try { return store?.setting?.(GROUP_LEVELS_FLAG, true) !== false } catch (e) { return true }
}

// Самый глубокий уровень со своим оформлением: level >= GROUP_LEVEL_CAP получает классы уровня GROUP_LEVEL_CAP
export const GROUP_LEVEL_CAP = 2

// Классы строки-группы уровня level: grp-level (маркер), grp-level-<n> (шрифт / отступ), grp-level-bg-<n> — фон уровня, ТОЛЬКО если у ячейки
// нет своей заливки (hasOwnClass: правило cssClass / именованный стиль с фоном / cell-background-* / inline-фон hslGroup).
// Некорректный уровень (undefined, отрицательный) считается нулевым.
// IE 2026 11 02 / ODOO-349799 (group-collapsed) (заказ Игоря, скрин «Конфігурація» по чипу «Вид, Підсистема»): СВЁРНУТАЯ группа — как свёрнутый узел дерева
// REPORT2 (AttrGrid formatItem_cells: `if (row.isCollapsed) {} else addClass(group-row-level-N)` — класс уровня с фоном и жирностью ставится только
// раскрытому узлу): ни фона уровня, ни жирности — только маркеры grp-level / grp-level-collapsed; иконка, отступ, направляющие и глиф остаются.
export function groupLevelClass(level, hasOwnClass, collapsed=false) {
    if (collapsed) return 'grp-level grp-level-collapsed'
    const lvl = Number.isInteger(level) && level >= 0 ? Math.min(level, GROUP_LEVEL_CAP) : 0
    const cls = ['grp-level', `grp-level-${lvl}`]
    if (!hasOwnClass) cls.push(`grp-level-bg-${lvl}`)
    return cls.join(' ')
}

// Направляющие слева у строки уровня level (лист под группами — maxGroupLevel + 1): по одной на каждого предка ilevel < level, как у дерева
// (цикл `for ilevel < row.level` в formatItem_cells_break). nextLevel — уровень следующей ВИДИМОЙ строки (-1 — строк дальше нет;
// лист — maxGroupLevel + 1); isLast — секция предка ilevel на этой строке закрывается (следующая строка не глубже предка) — у дерева
// `ilevel + 1 > rows[iNext].level`: в режиме рамки там рисуется угол и горизонталь.
export function groupGuides(level, nextLevel) {
    const lvl = Number.isInteger(level) && level > 0 ? level : 0
    const nl = Number.isInteger(nextLevel) ? nextLevel : -1
    const out = []
    for (let ilevel = 0; ilevel < lvl; ilevel++) out.push({ ilevel, isLast: nl <= ilevel })
    return out
}

// Отступ направляющей предка ilevel от левого края ячейки: wijmo сдвигает содержимое колонки дерева на cellPadLeft + level × treeIndent
// (updateCell: `treeIndent * level + _cellPadLeft`), глиф свёртки стоит ещё на glyphX правее (промер treeLines_frameGlyph) —
// линия предка идёт под его глифом
export function groupGuide_x(glyphX, cellPadLeft, treeIndent, ilevel) {
    const g = Number(glyphX) || 0, p = Number(cellPadLeft) || 0, t = Number(treeIndent) || 0
    return g + p + Math.max(0, Number(ilevel) || 0) * t
}
